import { Navigate, useLocation } from 'react-router-dom';
import { trpc } from '../lib/api';
import { isAdminPath } from '../lib/adminPaths';

interface Props {
  children: React.ReactNode;
}

// Guard that redirects non-admin users to /maintenance when maintenance mode targets them.
export function MaintenanceGuard({ children }: Props) {
  const location = useLocation();
  const isMaintenancePage = location.pathname.startsWith('/maintenance');
  const isAdminRoute = isAdminPath(location.pathname);

  const statusQuery = trpc.maintenanceMode.checkStatus.useQuery(undefined, {
    refetchInterval: 180000, // 3分ごとにチェック
    retry: 1,
    enabled: !isAdminRoute, // 管理画面は除外
  });

  if (isAdminRoute) {
    return <>{children}</>;
  }

  if (statusQuery.isLoading) {
    // Keep showing the existing UI while we confirm status to avoid flicker
    return <>{children}</>;
  }

  const isInMaintenance = statusQuery.data?.isInMaintenance;

  if (!isMaintenancePage && isInMaintenance) {
    return <Navigate to="/maintenance" replace />;
  }

  return <>{children}</>;
}